"use client";
import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { WcButton } from "../input/WcButton/WcButton";

export const WcDraggable = (props: any) => {
  const { id, dataObject } = props;
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    disabled: props.disabled,
    id: id,
    data: dataObject ? dataObject : "",
  });
  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      }
    : undefined;
  return (
    <WcButton fullWidth variant="contained" color="primary" ref={setNodeRef} style={style} {...listeners} {...attributes}>
      {props.children}
    </WcButton>
  );
};
